import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import API from '../../../utils/API';
import commonFunctions from '../../../utils/commonFunctions';
import InputValidation from '../../../utils/InputValidation';
const AddNewPlaylist = ({ setSuccess, closeModal, refreshData, setSelectedPlaylistId, user }) => {
  const [playlistName, setPlaylistName] = useState('');
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [playlistNameValid, setPlaylistNameValid] = useState('');
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const resetModal = () => {
    setSubmitted(false);
    setModalError('');
    setPlaylistName('');
    setPlaylistNameValid('');
  };

  useEffect(() => {
    const modalElement = document.getElementById('addNewPlaylistModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);
    return () => modalElement.removeEventListener('hidden.bs.modal', resetModal);
  }, []);

  const validatePlaylistName = (name) => {
    if (InputValidation.validateEmpty(name.trim())) return 'EMPTY_FIELD_ERROR';
    if (name.trim().length < 2 || name.trim().length > 36) return 'PLAYLIST_NAME_LENGTH';
    return '';
  };

  const handleChange = (e) => {
    const value = e.target.value/*.trim()*/;
    setPlaylistName(value);
    setPlaylistNameValid(validatePlaylistName(value));
  };

  const handleAdd = async () => {
    try {
      const res = await API.addPlaylist({ name: playlistName.trim() });
      setSuccess(<FormattedMessage id="ADD_PLAYLIST_SUCCESS" />);
      if (typeof refreshData === 'function') await refreshData();
      setSelectedPlaylistId(res.data.id);
      closeModal("addNewPlaylistModal");
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setModalError(<FormattedMessage id={err.response.data.message} defaultMessage={err.message} />);
        return;
      }
      setModalError(<FormattedMessage id="ADD_PLAYLIST_FAILED" values={{ errorMsg: <b>{err.message}</b> }} />);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const validationError = validatePlaylistName(playlistName);
    if (validationError) {
      setPlaylistNameValid(validationError);
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
      return;
    }
    handleAdd();
  };

  return (
    <div className='modal modal-mse fade' id='addNewPlaylistModal' tabIndex='-1' aria-labelledby='addNewPlaylistModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='ADD_NEW_PLAYLIST' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='folderNameSection mb-2'>
                  <label htmlFor='playlistNameInput' className='font-weight-600 font-size-14 mb-2'>
                    <FormattedMessage id='PLAYLIST_NAME' />:
                  </label>
                  <input
                    id="playlistNameInput"
                    onChange={handleChange}
                    value={playlistName}
                    name='playlistName'
                    placeholder={t('PLAYLIST_NAME')}
                    className={`form-control h-54 bg-baby-blue ${submitted && (playlistNameValid ? 'is-invalid' : 'is-valid')}`}
                  />
                  {commonFunctions.InvalidFeedbackString(playlistNameValid, 'PLAYLIST_NAME')}
                </div>
                {submitted && modalError && (
                  <div className='modal-error invalid-feedback d-block fw-bold text-center'>
                    {modalError}
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              <FormattedMessage id='ADD_NEW_PLAYLIST' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(AddNewPlaylist);
